import React from 'react';
import { Transition } from 'react-transition-group';
import PropTypes from 'prop-types';
import css from './AnimatedElement.module.scss';
import classNames from 'classnames';

const duration = 0;

const AnimatedElement = ({ children, inProp, customClass, styles }) => (
    <Transition in={inProp} timeout={duration} mountOnEnter unmountOnExit>
        {(state) => (
            <div className={classNames(css.defaultStyle, css[state], customClass)} style={{ ...styles }}>
                {children}
            </div>
        )}
    </Transition>
);

AnimatedElement.propTypes = {
    inProp: PropTypes.bool,
    styles: PropTypes.object
};

export default AnimatedElement;
